import React, { useState } from 'react'
import Error from './error';
import Cookies from 'universal-cookie';

const Formulario = ({guardarBusquedaOrden}) => {


    const cookiees = new Cookies();


    const [busqueda, guardarbusqueda] = useState ({
        paciente: '',
        numorden: ''
    })

    const [error, guardarerror]= useState(false);

    const {paciente=[], numorden=[]}=busqueda;


    //funcion para leer cada input

    const actualizarState = e =>{
        guardarbusqueda ({
            ...busqueda, 
            [e.target.name] : e.target.value
        })
    }

    //refrescar State
     


    
    //consultar la API

    const buscarOrden = e => {
        e.preventDefault();

        if (paciente.trim()==='' || numorden.trim()===''){
            guardarerror(true);
            return;
        }
        guardarerror(false)
        // si esta todo bien pasar al componente principal
     
        guardarBusquedaOrden(busqueda);
   }

  // guardarbusqueda({
    //   paciente:'',
      // numorden:''
   //})

 
 
    return (

        <body>
            
            <div className="container">
                <div className="row justify-content-left">
                
                <div className="col-sm-3 text-center">

                    <form  className="form-horizontal" 
                    onSubmit={buscarOrden}       
                    >
                                <a href="/">
                                    <img src="Cebac.png"
                                    className="mx-auto d-block"
                                    width="288" height="220"/>
                                </a>
                            <div className="form-group">
                    
                            <div className="input-group">
                                    
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon">
                                    <i className="fa fa-address-card-o"></i>
                                    </span>
                                </div>                      
                    
                                    <input
                                    
                                    type="text"
                                    className="form-control"
                                    name="paciente"
                                    placeholder="DNI del Paciente"
                                    onChange={actualizarState}
                                    value={paciente}/>
                            </div>       
                            </div> 
                            <div className="form-group">
                            <div className="input-group">
                                
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon">
                                    <i className="fa fa-file-code-o"></i>
                                    </span>
                                </div>                  
                            <input
                                type="text"
                                className="form-control"
                                name="numorden"
                                placeholder="Numero Orden"
                                onChange={actualizarState}
                                value={numorden}
                            />
                            </div>
                            </div>
                           
                            <div className = "form-group">
                                { error ? <Error mensajes="Orden  No Encontrada"/>  :null}
                        
                                <button 
                                    type="submit" 
                                    className="btn btn-info btn-block"
                        
                                    >Buscar</button>
                            </div>
                
                          
                    
                    </form>
                    </div>
                </div>
                </div>
             </body>     
        
    )
}

export default Formulario;

